import { useKeyPressed } from "@/hooks/useKeyPressed";
import { usePathname } from "@/i18n/navigation";
import { getRouteDetails } from "@/utils/routeHelper";
import { useCallback, useEffect, useState } from "react";

export const useNavbarState = () => {
  const pathname = usePathname();
  const routeDetails = getRouteDetails(pathname);
  const {
    isHome,
    isPayment,
    isFlightHome,
    isHotelHome,
    isBusTicketHome,
    isFerryTicketHome,
    isCarRentalHome,
    isReservation,
  } = routeDetails;

  const [isOpen, setIsOpen] = useState(false);
  const isEscaped = useKeyPressed("Escape");

  // Escape key handler
  useEffect(() => {
    if (isEscaped && isOpen) {
      setIsOpen(false);
    }
  }, [isEscaped, isOpen]);

  // Reset states on route change
  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  const toggleOpen = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  // Hover handler'lar boş - CSS hover zaten çalışıyor
  const handleMouseEnter = useCallback(() => {
    // CSS md:hover:w-61 ile hover effect zaten çalışıyor
  }, []);

  const handleMouseLeave = useCallback(() => {
    // CSS md:hover:w-61 ile hover effect zaten çalışıyor
  }, []);

  // Collapsed state logic - route, isOpen VE ekran genişliğine bağlı
  const isCollapsed =
    !pathname.includes("register") &&
    !pathname.includes("about-us") &&
    !isHome &&
    !isFlightHome &&
    !isReservation &&
    !isHotelHome &&
    !isBusTicketHome &&
    !isFerryTicketHome &&
    !isCarRentalHome &&
    !isOpen &&
    !isPayment;
  // windowWidth > 1450;

  return {
    isOpen,
    isCollapsed,
    toggleOpen,
    close,
    handleMouseEnter,
    handleMouseLeave,
  };
};
